import "core-js/modules/es.array.includes.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, Suspense as _Suspense, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-72b021f4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "LogicalReasoningRenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = {
  class: "ans-box"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, " 题目图预览 ", -1));
const _hoisted_5 = {
  class: "flex flex-col"
};
const _hoisted_6 = {
  class: "left"
};
const _hoisted_7 = {
  class: "flex items-center"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin": "30px"
  }
}, " 请观察左侧的骰子顶部图标，在右侧的选项中找到与左侧骰子顶部图标相同的选项。 ", -1));
const _hoisted_9 = {
  class: "content"
};
const _hoisted_10 = {
  class: "left"
};
const _hoisted_11 = {
  class: "right"
};
const _hoisted_12 = {
  class: "flex flex-col"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "正确答案：", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "您的答案：", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_DiceItem = _resolveComponent("DiceItem");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_col = _resolveComponent("el-col");
  return $props.data ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
    _: 1
  }), _createVNode(_component_el_divider, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.activeTab === 'problem' ? '题目预览' : '选项预览'), 1)]),
    _: 1
  }), $props.editMode ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [(_openBlock(), _createBlock(_Suspense, null, {
    default: _withCtx(() => [(_openBlock(), _createBlock(_component_DiceItem, {
      onOnSaveImage: $options.handleSaveImage,
      "cube-icons": $props.data.question,
      "preview-images": $data.previewData[$props.data.questionIndex],
      "local-index": 0,
      "is-desc": "",
      key: `question_${$props.data.questionIndex}_${$options.hash($props.data.question)}`
    }, null, 8, ["onOnSaveImage", "cube-icons", "preview-images"]))]),
    _: 1
  })), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_divider, null, {
    default: _withCtx(() => [_createTextVNode("正确答案 " + _toDisplayString($props.data.rightAnswer), 1)]),
    _: 1
  }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.answers, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: `${$props.data.questionIndex}_${index}_${$options.hash($props.data.question)}`,
      class: "item-box"
    }, [_createVNode(_component_el_row, {
      class: "bothCenter"
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, "选项 " + _toDisplayString($data.letters[index]), 1)]),
      _: 2
    }, 1024), (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [_createVNode(_component_DiceItem, {
        onOnSaveImage: $options.handleSaveImage,
        "cube-icons": item,
        "preview-images": $data.previewData[$props.data.questionIndex],
        "local-index": index,
        "is-desc": false
      }, null, 8, ["onOnSaveImage", "cube-icons", "preview-images", "local-index"])]),
      _: 2
    }, 1024))]);
  }), 128))]), _createVNode(_component_el_divider), _hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_image, {
    style: {
      "height": "120px"
    },
    src: $data.previewData[$props.data.questionIndex]?.question ?? ''
  }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.previewData[$props.data.questionIndex]?.answers, (item, index) => {
    return _openBlock(), _createBlock(_component_el_image, {
      style: {
        "height": "120px",
        "margin-right": "10px"
      },
      key: index,
      src: item ?? ''
    }, null, 8, ["src"]);
  }), 128))])])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [(_openBlock(), _createBlock(_Suspense, null, {
    default: _withCtx(() => [(_openBlock(), _createBlock(_component_DiceItem, {
      "cube-icons": $props.data.question,
      size: {
        width: 250,
        height: 250
      },
      "is-save": false,
      key: `question_render_${$props.data.questionIndex}_${$options.hash($props.data.question)}`,
      "is-desc": ""
    }, null, 8, ["cube-icons"]))]),
    _: 1
  }))]), _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.answers, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: `${$props.data.questionIndex}_${index}_${$options.hash(item)}`,
      style: {
        "display": "flex",
        "flex-direction": "column",
        "margin": "5px"
      }
    }, [(_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [(_openBlock(), _createBlock(_component_DiceItem, {
        "cube-icons": item,
        size: {
          width: 220,
          height: 220
        },
        "is-save": false,
        key: `answer_render_${$props.data.questionIndex}_${index}_${$options.hash(item)}`
      }, null, 8, ["cube-icons"]))]),
      _: 2
    }, 1024)), _createVNode(_component_el_button, {
      disabled: $props.reviewMode,
      type: $data.select.includes(String.fromCharCode(65 + index)) ? 'primary' : '',
      style: {
        "margin-top": "10px"
      },
      onClick: $event => $options.onChoosed(String.fromCharCode(65 + index))
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(String.fromCharCode(65 + index)), 1)]),
      _: 2
    }, 1032, ["disabled", "type", "onClick"])]);
  }), 128))])]), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "bothCenter mt32"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_col, {
      class: "flex items-center"
    }, {
      default: _withCtx(() => [_hoisted_13, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.rightAnswers, (ra, rai) => {
        return _openBlock(), _createBlock(_component_el_tag, {
          type: "info",
          style: {
            "width": "30px",
            "margin-left": "8px"
          },
          key: rai
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(ra), 1)]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    }), $props.review ? (_openBlock(), _createBlock(_component_el_col, {
      key: 0,
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_hoisted_14, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.review.answer.split(','), (ra, rai) => {
        return _openBlock(), _createBlock(_component_el_tag, {
          style: {
            "width": "30px",
            "margin-left": "8px"
          },
          type: $props.data.rightAnswers[rai] == ra ? 'success' : 'danger',
          key: rai
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(ra), 1)]),
          _: 2
        }, 1032, ["type"]);
      }), 128))]),
      _: 1
    })) : _createCommentVNode("", true)])]),
    _: 1
  })) : _createCommentVNode("", true)], 64))])) : _createCommentVNode("", true);
}